import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import './card.scss';

interface Props extends PropsWithChildren {
  className?: string;
}

export const Card = ({ children, className }: Props) => {
  return <div className={classNames('payflow-ui payflow-card', className)}>{children}</div>;
};
